import React from 'react'
import { Box } from '@mui/material'
import { useCardDetailContext } from '../CardDetailContext';
import { styled } from '@mui/material/styles';
import { ReactComponent as SampleBadge } from '../../Assets/img/card/sample-badge.svg'
import DefaultProfilePic from '../../Assets/img/card/profilebg.png'
import PropTypes from 'prop-types';

import CardWaveStd from './CardWaveStd';
import CardWaveSmile from './CardWaveSmile2';
import CardWaveSlope from './CardWaveSlope2';
import CardWaveFlat from './CardWaveFlat';

import dr1 from '../../Assets/img/Thumbnails/dr-1-thumbnail.png'
import dr2 from '../../Assets/img/Thumbnails/dr-2-thumbnail.png'
import adv1 from '../../Assets/img/Thumbnails/adv-1-thumbnail.png'
import adv2 from '../../Assets/img/Thumbnails/adv-2-thumbnail.png'
import it1 from '../../Assets/img/Thumbnails/it-1-thumbnail.png'
import it2 from '../../Assets/img/Thumbnails/it-2-thumbnail.png'
import ca1 from '../../Assets/img/Thumbnails/ca-1-thumbnail.png'
import ca2 from '../../Assets/img/Thumbnails/ca-2-thumbnail.png'
import hr1 from '../../Assets/img/Thumbnails/hr-1-thumbnail.png'
import hr2 from '../../Assets/img/Thumbnails/hr-2-thumbnail.png'
import fr1 from '../../Assets/img/Thumbnails/fr-1-thumbnail.png'
import fr2 from '../../Assets/img/Thumbnails/fr-2-thumbnail.png'
import cs1 from '../../Assets/img/Thumbnails/cs-1-thumbnail.png'
import cs2 from '../../Assets/img/Thumbnails/cs-2-thumbnail.png'
import bank1 from '../../Assets/img/Thumbnails/bank-1-thumbnail.png'
import bank2 from '../../Assets/img/Thumbnails/bank-2-thumbnail.png'

const LayoutBox = styled(Box)(({ isSelected }) => ({
    border: isSelected ? "1px solid #0044c6" : "1px solid #0000001F",
    borderRadius: 8, // 16px
    height: "125px",
    width: "100px",
    cursor: "pointer",
    transition: "0.2s border ease",
    boxShadow: isSelected ? "0px 4px 4px 0px #00000026" : 'none',
    '&:hover': {
        border: "1px solid #0044c6", // Change border color on hover
        boxShadow: "0px 4px 4px 0px #00000026",
    }
}));

const ProfCardBox = styled(Box)(({ isSelected }) => ({
    border: isSelected ? "1px solid #0044c6" : "1px solid #0000001F",
    height: "64px",
    width: "125px",
    cursor: "pointer",
    transition: "0.2s border ease",
    boxShadow: isSelected ? "0px 4px 4px 0px #00000026" : 'none',
    '&:hover': {
        border: "1px solid #0044c6", // Change border color on hover
        boxShadow: "0px 4px 4px 0px #00000026",
    },
    backgroundColor: "white",
    display: "block"
}));

const LayoutOption = ({ optionNumber, isSelected, handleSelect, category, useCardContext }) => {

    const { cardDetails, CardStyles } = useCardContext();

    const profilePic = cardDetails?.profile_pic ? cardDetails?.profile_pic : DefaultProfilePic;

    const isDefaultPic = profilePic === DefaultProfilePic;

    const isFullImage = ['1', '2', '3', '4', '7'].includes(optionNumber) ? true : false;

    if (category === 'regular')
        return (
            <>
                <LayoutBox isSelected={isSelected} onClick={() => handleSelect(optionNumber)}>
                    {isFullImage ?
                        <div className='layout-upper-full-img'>
                            <div className="label-placeholder" style={{ backgroundColor: CardStyles?.colorLayout }} />
                            <div className='full-picture-container' >
                                <img src={profilePic} alt="Profile" />
                            </div>
                            {optionNumber === '1' && (
                                <>
                                    <CardWaveStd strokeColor={CardStyles?.colorLayout} />
                                    <div className='layout-option-logo opt-1' />
                                </>
                            )}
                            {optionNumber === '2' && (
                                <>
                                    <CardWaveSmile strokeColor={CardStyles?.colorLayout} />
                                    <SampleBadge className='layout-option-badge opt-2' />
                                </>
                            )}
                            {optionNumber === '3' && (
                                <>
                                    <CardWaveFlat strokeColor={CardStyles?.colorLayout} small />
                                    <div className='layout-option-logo opt-3' />
                                </>
                            )}
                            {optionNumber === '4' && (
                                <>
                                    <CardWaveSmile strokeColor={CardStyles?.colorLayout} />
                                    <div className='flex-center' style={{ position: "absolute", width: "100%" }}>
                                        <div className='layout-option-name-box opt-4' />
                                    </div>
                                </>
                            )}
                            {optionNumber === '7' && (
                                <>
                                    <CardWaveSlope strokeColor={CardStyles?.colorLayout} />
                                    <div className='layout-option-logo opt-7' />
                                </>
                            )}
                        </div>
                        :
                        <div className='layout-upper-circle-img'>
                            <div className="label-placeholder" style={{ backgroundColor: CardStyles?.colorLayout }} />
                            {optionNumber === '5' && (
                                <>
                                    <div className='mx-auto flex-center circle-img-wrapper opt-5'>
                                        <div className='circle-img-container opt-5' style={{ border: isDefaultPic ? '1px solid #ccc' : '' }} >
                                            <img src={profilePic} alt="Profile" />
                                            <div className='layout-option-logo opt-5' />
                                        </div>
                                    </div>
                                </>
                            )}
                            {optionNumber === '6' && (
                                <>
                                    {/* <div className="layout-logo-container" style={{height: "24px", width: "24px", borderRadius: "2px", backgroundColor: "#D1D1D1", position: "absolute", top: "6px", right: 0}}/> */}
                                    <div className='mx-auto flex-center circle-img-wrapper opt-6'>
                                        <img src={profilePic} alt="Profile" style={{ border: isDefaultPic ? '1px solid #ccc' : '' }} />
                                        <div className='profile-decor-line opt-6' style={{ backgroundColor: CardStyles.colorLayout }} />
                                    </div>
                                </>
                            )}
                            {optionNumber === '8' && (
                                <>
                                    <div className='mx-auto flex-center circle-img-wrapper opt-8'>
                                        <div className='flex-center circle-img-container opt-8'>
                                            <img src={profilePic} alt="Profile" style={{ position: "relative", border: isDefaultPic ? '1px solid #ccc' : '' }} />
                                            <div className='layout-option-name-box opt-8' />
                                        </div>
                                    </div>
                                </>
                            )}
                        </div>
                    }
                </LayoutBox>
            </>
        )
    else if (category === 'prof')
        return (
            <>
                <ProfCardBox isSelected={isSelected} onClick={() => handleSelect(optionNumber)}>
                    {optionNumber === 'ca1' && (
                        <img src={ca1} alt="Doctor 1" className='cover-image' />
                    )}
                    {optionNumber === 'ca2' && (
                        <img src={ca2} alt="Doctor 1" className='cover-image' />
                    )}
                    {optionNumber === 'hr1' && (
                        <img src={hr1} alt="Doctor 1" className='cover-image' />
                    )}
                    {optionNumber === 'hr2' && (
                        <img src={hr2} alt="Doctor 1" className='cover-image' />
                    )}
                    {optionNumber === 'bk1' && (
                        <img src={bank1} alt="Doctor 1" className='cover-image' />
                    )}
                    {optionNumber === 'bk2' && (
                        <img src={bank2} alt="Doctor 1" className='cover-image' />
                    )}
                    {optionNumber === 'fl1' && (
                        <img src={fr1} alt="Doctor 1" className='cover-image' />
                    )}
                    {optionNumber === 'fl2' && (
                        <img src={fr2} alt="Doctor 1" className='cover-image' />
                    )}
                    {optionNumber === 'cs1' && (
                        <img src={cs1} alt="Doctor 1" className='cover-image' />
                    )}
                    {optionNumber === 'cs2' && (
                        <img src={cs2} alt="Doctor 1" className='cover-image' />
                    )}
                    {optionNumber === 'it1' && (
                        <img src={it1} alt="Doctor 1" className='cover-image' />
                    )}
                    {optionNumber === 'it2' && (
                        <img src={it2} alt="Doctor 1" className='cover-image' />
                    )}
                    {optionNumber === 'adv1' && (
                        <img src={adv2} alt="Doctor 1" className='cover-image' />
                    )}
                    {optionNumber === 'adv2' && (
                        <img src={adv1} alt="Doctor 1" className='cover-image' />
                    )}
                    {optionNumber === 'dr1' && (
                        <img src={dr2} alt="Doctor 1" className='cover-image' />
                    )}
                    {optionNumber === 'dr2' && (
                        <img src={dr1} alt="Doctor 2" className='cover-image' />
                    )}
                </ProfCardBox>
            </>
        )
}

export default LayoutOption

LayoutOption.propTypes = {
    category: PropTypes.oneOf(['regular', 'prof']), // Add inputType prop
    handleSelect: PropTypes.func // Optional prop for contact details context
}

LayoutOption.defaultProps = {
    category: 'regular',
}
